<template>
  <a-empty :image="emptyImage" style="margin-top: 24px; margin-bottom: 0">
    <template #description>
      <div style="color: #666; margin-top: 16px">暂无数据</div>
    </template>
  </a-empty>
</template>

<script>
import { Empty } from 'ant-design-vue'

export default {
  name: 'CommonEmpty',

  data() {
    return {
      emptyImage: Empty.PRESENTED_IMAGE_SIMPLE
    }
  }
}
</script>

<style scoped></style>
